import React from 'react';
import { Navigate } from 'react-router-dom';
import Training from '../../pages/Training';
import { useAuth } from '../../context/AuthContext';
import { isCertExcluded } from '../../shared/teamLeadCertAccess';

export default function TeamLeadCertRoute() {
  const { user, viewAsUser } = useAuth();
  const email = viewAsUser ? viewAsUser.email : user?.email;
  if (isCertExcluded({}, email)) return <Navigate to="/training" replace />;
  return <Training moduleKey="teamLeadCert" />;
}
